import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 20,
	fill: "none",
	viewBox: "0 0 21 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#a)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "#4285F4",
					d: "M16.934 17.574c2.319-2.203 3.349-5.876 2.73-9.39h-9.22v3.882h5.254c-.206 1.259-.927 2.308-1.957 2.99l3.194 2.518Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#34A853",
					d: "M1.688 14.478a10.21 10.21 0 0 0 1.227 1.897 10.03 10.03 0 0 0 2.07 1.9 9.828 9.828 0 0 0 4.14 1.617 9.675 9.675 0 0 0 3.335-.1 9.686 9.686 0 0 0 2.124-.697 9.648 9.648 0 0 0 1.462-.832 10.006 10.006 0 0 0 .889-.69l-3.194-2.518c-2.73 1.836-7.263 1.154-8.808-3.148l-3.245 2.57Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#FBBC02",
					d: "M4.932 11.908c-.412-1.312-.412-2.518 0-3.83l-3.245-2.57c-1.185 2.413-1.545 5.823 0 8.97l3.245-2.57Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#EA4335",
					d: "M4.933 8.08c1.133-3.62 5.975-5.719 9.22-2.623l2.833-2.833C12.968-1.311 5.14-1.153 1.687 5.509l3.246 2.57Z"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "a",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M.25 0h20v20h-20z"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgGoogle);
export { ForwardRef as ReactComponent };
